var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import LossLocationMap from './LossLocationMap';

var MapCtrl = function () {
    function MapCtrl() {
        _classCallCheck(this, MapCtrl);
    }

    _createClass(MapCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.validateProps();
            setTimeout(function () {
                return _this.initMap();
            }, 0);
        }
    }, {
        key: 'validateProps',
        value: function validateProps() {
            if (!this.mapName) {
                console.warn('You don\'t provide unique `mapName` property of map component. ' + 'It may cause problems if you have more than one map component on page.');
            }
        }
    }, {
        key: 'initMap',
        value: function initMap() {
            if (window.google && window.google.maps) {
                this.map = new LossLocationMap({
                    mapsApi: window.google.maps,
                    coords: this.coords,
                    onPositionChange: this.onPositionChange
                }).init(document.getElementById(this.mapName || 'googleMapsComponent'));
            } else {
                console.warn('Google Maps API not loaded.');
            }
        }
    }]);

    return MapCtrl;
}();

export default MapCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/common/directives/LossLocationMap/LossLocationMapCtrl.js
// module id = 1524
// module chunks = 0